import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <div className='footer'>
        <div>
          <a className='git-icons' href="https://github.com/tiffanybibby" target="blank"> <img className="github-img" src="https://github.com/tiffanybibby/encapsule/blob/main/assets/github-logo.png?raw=true" alt='github icon' /> </a>
          <a className='TNDR-name' href="https://www.linkedin.com/in/tiffanybibby" target="blank">Tiffany Diandra</a>
        </div>
        <div>
          <a className='git-icons' href="https://github.com/Nia-Emani" target="blank"> <img className="github-img" src="https://github.com/tiffanybibby/encapsule/blob/main/assets/github-logo.png?raw=true" alt='github icon' /> </a>
          <a className='TNDR-name' href="https://www.linkedin.com/in/nia-emani-dickson-6b4b6421/" target="blank">Nia-Emani</a>
        </div>
        <p className='team-name'>©T-N-D-R</p>
        <div>
          <a className='git-icons' href="https://github.com/DariaKrestina" target="blank"> <img className="github-img" src="https://github.com/tiffanybibby/encapsule/blob/main/assets/github-logo.png?raw=true" alt='github icon' /> </a>
          <a className='TNDR-name' href="https://www.linkedin.com/in/daria-krestina/" target="blank">Daria Krestina</a>
        </div>
        <div>
          <a className='git-icons' href="https://github.com/texasrachel" target="blank"> <img className="github-img" src="https://github.com/tiffanybibby/encapsule/blob/main/assets/github-logo.png?raw=true" alt='github icon' /> </a>
          <a className='TNDR-name' href="https://www.linkedin.com/in/texasrachel" target="blank">Rachel Ginnett</a>
        </div>
      </div>
    </footer>
  )
}
export default Footer